import React from 'react'
import PropTypes from 'prop-types'
import { Navbar } from 'reactstrap'
import { Brand } from './brand'
import { NavigationWithLogout } from './navigation-with-logout'

export function NavbarTopNoToggle (props) {
  return (
    <Navbar className='fixed-top navbar-dark'>
      <Brand />
      <div className='navbar-collapse-sidebar'>
        <NavigationWithLogout url={props.url} />
      </div>
    </Navbar>
  )
}

NavbarTopNoToggle.propTypes = {
  url: PropTypes.object
}
